export default __webpack_public_path__ + "static/media/01_06.813cfb11.jpg";